const TeamList = [
    {
        image: "/Sangita-Jindal-min.jpg",
        title: "Sangita Jindal",
        description: "Chairperson of JSW Foundation and Founder of Art India Magazine & Art India Education",
        link: "/teams/sangita-jindal"
    },
    {
        image: "/Abhay-Sardesai-min.jpg",
        title: "Abhay Sardesai",
        description: "Former Editor of Art India Magazine",
        link: "/teams/abhay-sardesai"
    },
    {
        image: "/Urshila-2.jpg",
        title: "Urshila Mehta",
        description: "Managing Liaison, Art & Culture, JSW Foundation",
        link: "/teams/urshila-mehta"
    },
    {
        image: "/Shweta-Upadhyay-min.jpg",
        title: "Shweta Upadhyay",
        description: "Assistant Editor, Art India Magazine",
        link: "/teams/shweta-upadhyay"
    },
    {
        image: "/Rupesh-Pandey-min.jpg",
        title: "Rupesh Pandey",
        description: "",
        link: "/teams/rupesh-pandey"
    },
    {
        image: "/Yvette-Baptista-min.jpg",
        title: "Yvette Baptista",
        description: "Editorial Coordinator, Art India Magazine",
        link: "/teams/yvette-baptista"
    },
];

export default TeamList;